module.exports = __webpack_public_path__ + "img/Celebrate2.e7712c59.png";